import { gql } from 'graphql-tag'

export const getPublicFeatureToggles = gql`
  query getPublicFeatureToggles {
    publicFeatureToggles {
      comboRedirects
    }
  }
`
